<span class="date-range-field-label">{{ label }}</span>
<mat-form-field [appearance]="appearance" class="date-range-field">
  <mat-date-range-input [rangePicker]="rangePicker" [formGroup]="formGroup">
    <input matStartDate [attr.aria-label]="label + ' desde'" [formControlName]="startControlName" [placeholder]="startPlaceholder">
    <input matEndDate [attr.aria-label]="label + ' hasta'" [formControlName]="endControlName" [placeholder]="endPlaceholder">
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
  <mat-date-range-picker #rangePicker></mat-date-range-picker>
</mat-form-field>
